import React from 'react';
import './Controls.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlayCircle } from '@fortawesome/free-solid-svg-icons';
import { faSync } from '@fortawesome/free-solid-svg-icons';

export default function Controls (props) {
    return (
        <div className="controls">
           <div className="buttons">
                <FontAwesomeIcon id="start_stop" className={props.status ? "start-icon-on" : "start-icon-off"} icon={faPlayCircle} onClick={props.start} />
                <FontAwesomeIcon id="reset" className={props.status ? "reset-icon-on" : "reset-icon-off"} icon={faSync} onClick={props.reset} />
           </div>
           <div id="timer-label" className="status">{props.isStyleAlert ? "Break" : props.status ? "Active" : "Paused"}</div>
        </div>
      )
    }
  
